export enum CaseStatus {
  NEW = 'New',
  INPROGRESS = 'InProgress',
  AWAITINGINFO = 'AwaitingInfo',
  RESOLVED = 'Resolved',
  SUBMITTED = 'Submitted',
  CLOSED = 'Closed',
  REOPEN = 'ReOpen',
}

export enum CaseType {
  DISPUTE = 'Dispute',
  INTERNALPROCESSING = 'Internal Processing',
  REQUESTFORINFO = 'Request a Copy/Info',
}

export enum CaseSubType {
  VENDOR_INCOME = 'Vendor Income',
}

export enum CaseText {
  NEWACTIVITY = 'New Case Creation',
  NEWREQACTIVITY = 'New Request Creation',
}

export enum Claim {
  IMPORTCLAIM = 4,
  IMPORTCASESUBTYPE = 'Claim',
}
export const defaultValues = [
  {
    id: 999,
    value: 999,
    label: 'NA',
  },
]

export const dvsWorkflow = 'TGTCOM'

export const TrailerType = [
  { id: 'Drop', value: 'Drop Trailer', label: 'Drop Trailer' },
  { id: 'Live', value: 'Live Trailer', label: 'Live Trailer' },
]

export const ClaimType = [
  { id: 'D', value: 'Damage', label: 'Damage' },
  { id: 'S', value: 'Shortage', label: 'Shortage' },
  { id: 'P', value: 'Pilferage', label: 'Pilferage' },
]

export const DocumentsNotification = [
  {
    id: '1',
    value: 'No External Damage Notification available',
    label: 'No External Damage Notification available',
  },
  {
    id: '2',
    value: 'BOL system down/not working',
    label: 'BOL system down/not working',
  },
  {
    id: '3',
    value: 'Open receipt DO NOT USE (Explain)',
    label: 'Open receipt DO NOT USE (Explain)',
  },
  {
    id: '4',
    value: 'No Delivery Receipt copy available',
    label: 'No Delivery Receipt copy available',
  },
  {
    id: '5',
    value: 'BOL not found in system',
    label: 'BOL not found in system',
  },
]

export const VI18_REASON_CODE = 'VI18'
export const VI19_REASON_CODE = 'VI19'
export const RTVS_MULTIPLE_REASONS_CODE_TEXT = 'RTVS Multiple reasons'
export const RTVS_DOC_PREFIX = 'RTVS'
export const CBDC_DOC_PREFIX = 'CBDC'
export const INVENTORY_REMOVAL_SUBTYPE = 'Inventory removal'

export const VI19_SUB_REASON_CODES = {
  ALLOWANCE: 'CE_ALLOWANCE',
  VENDOR_NUMBER: 'CE_VENDOR_NUMBER',
  PROMO_ID: 'CE_PROMO_ID',
  DPCI_MIC: 'CE_DPCI_MIC',
  DATES: 'CE_DATES',
  AMOUNT_PER_UNIT: 'CE_AMOUNT_PER_UNIT',
  PAYMENT_METHOD: 'CE_PAYMENT_METHOD',
  PROMO_EVENT: 'CE_PROMO_EVENT',
}

export const VI19_SUB_REASON_CATEGORIES = {
  NUMERIC: [VI19_SUB_REASON_CODES.VENDOR_NUMBER],
  TEXT: [
    VI19_SUB_REASON_CODES.ALLOWANCE,
    VI19_SUB_REASON_CODES.PROMO_ID,
    VI19_SUB_REASON_CODES.DPCI_MIC,
    VI19_SUB_REASON_CODES.DATES,
  ],
  CURRENCY: [VI19_SUB_REASON_CODES.AMOUNT_PER_UNIT],
  SELECT: [VI19_SUB_REASON_CODES.PAYMENT_METHOD],
}

export const REASON_CODE_CONFIG = {
  [VI18_REASON_CODE]: {
    editLabel: 'What is the duplicate contract ID number?',
    viewLabel: 'Duplicate contract ID number',
    helperText: 'Comma delimit contract ID numbers',
  },
  [VI19_REASON_CODE]: {
    [VI19_SUB_REASON_CODES.ALLOWANCE]: {
      editLabel: 'What is the correct allowance percentage?',
      viewLabel: 'Correct allowance percentage',
      helperText: 'Use numbers and decimal points only',
    },
    [VI19_SUB_REASON_CODES.AMOUNT_PER_UNIT]: {
      editLabel: 'What is the correct amount per unit?',
      viewLabel: 'Correct amount per unit',
      helperText: 'Use numbers only',
    },
    [VI19_SUB_REASON_CODES.VENDOR_NUMBER]: {
      editLabel: 'What is the correct vendor number?',
      viewLabel: 'Correct vendor number',
      helperText: 'Use numbers only',
    },
    [VI19_SUB_REASON_CODES.DPCI_MIC]: {
      editLabel: 'What is the correct DPCI(s) or MIC(s)?',
      viewLabel: 'Enter correct DPCI(s) or MIC(s)',
      helperText: 'Comma delimit multiple DPCI/MIC numbers',
    },
    [VI19_SUB_REASON_CODES.DATES]: {
      editLabel: 'What is the correct Date?',
      viewLabel: 'Correct date',
      helperText: 'Format MM/DD/YYYY',
    },
    [VI19_SUB_REASON_CODES.PROMO_ID]: {
      editLabel: 'What is the correct promo ID number(s)?',
      viewLabel: 'Correct promo ID number(s)',
      helperText: 'Comma delimit multiple promo ID numbers',
    },
    [VI19_SUB_REASON_CODES.PAYMENT_METHOD]: {
      editLabel: 'What is the correct payment method?',
      viewLabel: 'Correct payment method',
      helperText: '',
    },
    [VI19_SUB_REASON_CODES.PROMO_EVENT]: {
      editLabel: '', // No input field needed for promo event
      viewLabel: '', // No input field needed for promo event
      helperText: '', // No helper text needed
    },
  },
}

export enum FormSections {
  VENDOR = 'vendor',
  DOCUMENT = 'document',
  CLAIM = 'claim',
  ATTACHMENT = 'attachment',
  SHORTAGE = 'shortage',
  REVIEW = 'review',
  CARRIER = 'carrier',
}

export const CaseSubTypes = [
  {
    caseType: 'Request a Copy/Info',
    caseSubType: 'Import Claims',
    ImportFlag: 'Y',
    DocTypeReqFlag: 'Y',
    amountValidation: 'N',
    reasonCode: 'Y',
  },
  {
    caseType: 'Request a Copy/Info',
    caseSubType: 'Vendor Income',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
  },
  {
    caseType: 'Request a Copy/Info',
    caseSubType: 'Delivery Receipt',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
  },
  {
    caseType: 'Request a Copy/Info',
    caseSubType: 'Proof Of Return',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
  },
  {
    caseType: 'Request a Copy/Info',
    caseSubType: 'Vendor Freight Audit',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
  },
  {
    caseType: 'Dispute',
    caseSubType: 'Import Claims',
    ImportFlag: 'Y',
    DocTypeReqFlag: 'Y',
    amountValidation: 'N',
    reasonCode: 'Y',
    PO: 'N',
  },
  {
    caseType: 'Dispute',
    caseSubType: 'Unpaid Invoice',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
    PO: 'N',
  },
  {
    caseType: 'Dispute',
    caseSubType: 'Deduction',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
    PO: 'N',
  },
  {
    caseType: 'Dispute',
    caseSubType: 'Vendor Credit',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
    PO: 'N',
  },
  {
    caseType: 'Dispute',
    caseSubType: 'Vendor Income',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
    PO: 'N',
  },
  {
    caseType: 'Dispute',
    caseSubType: 'Vendor Compliance',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
    PO: 'Y',
  },
  {
    caseType: 'Dispute',
    caseSubType: 'Vendor Freight Audit',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    reasonCode: 'Y',
    PO: 'Y',
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    ImportFlag: 'Y',
    DocTypeReqFlag: 'Y',
    amountValidation: 'Y',
    PO: 'N',
    Location: 'N',
    carrierVendor: 'Y',
    CarrierPO: 'Y',
    reasonCode: 'Y',
    sourceDocumentAmount: 'Y',
    disputedAmount: 'Y',
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'CBDC',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    PO: 'N',
    Location: 'Y',
    carrierVendor: 'N',
    CarrierPO: 'N',
    reasonCode: 'N',
    sourceDocumentAmount: 'N',
    disputedAmount: 'N',
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'Y',
    PO: 'Y',
    Location: 'N',
    carrierVendor: 'Y',
    CarrierPO: 'N',
    reasonCode: 'Y',
    sourceDocumentAmount: 'Y',
    disputedAmount: 'Y',
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'PO Correction',
    ImportFlag: 'N',
    DocTypeReqFlag: 'N',
    amountValidation: 'N',
    PO: 'Y',
    Location: 'Y',
    carrierVendor: 'N',
    CarrierPO: 'N',
    reasonCode: 'N',
    sourceDocumentAmount: 'N',
    disputedAmount: 'N',
  },
]

export const FieldsMapping = [
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 22,
    documentTypeText: 'DCR -DC RETURNS',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'DCR',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: true,
      retailAmount: true,
      inventoryRemovalId: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: true,
      locationId: true,
      classId: true,
      carrierPurchaseOrderNumber: true,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: true,
      retailAmount: true,
      inventoryRemovalId: false,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 20,
    documentTypeText: 'DAM -DAMAGE',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'DAM',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      carrierPurchaseOrderNumber: true,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 48,
    documentTypeText: 'SHT -SHORTAGE',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'SHT',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      carrierPurchaseOrderNumber: true,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 26,
    documentTypeText: 'EXR -EXPENSE RECOVERY',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'EXR',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      carrierPurchaseOrderNumber: true,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 49,
    documentTypeText: 'SOS -SORT & SEG',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'SOS',
    displayFields: {
      originalDocumentAmount: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: false,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: true,
      totalCartons: true,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: false,
      carrierPurchaseOrderNumber: true,
      reasonCode: true,
      originalDocumentAmount: false,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
      containerNumber: true,
      totalCartons: true,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: null,
    documentTypeText: null,
    documentSubTypeId: null,
    documentSubTypeText: null,
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: true,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'CBDC',
    documentTypeId: null,
    documentTypeText: null,
    documentSubTypeId: null,
    documentSubTypeText: null,
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: false,
      purchaseOrderNumber: false,
      departmentId: true,
      locationId: true,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: false,
      originalDocumentAmount: false,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: null,
    documentTypeText: null,
    documentSubTypeId: null,
    documentSubTypeText: null,
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'PO Correction',
    documentTypeId: null,
    documentTypeText: null,
    documentSubTypeId: null,
    documentSubTypeText: null,
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: false,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: false,
      originalDocumentAmount: false,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 10,
    documentTypeText: 'Domestic',
    documentSubTypeId: 2,
    documentSubTypeText: 'Shortage',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 12,
    documentTypeText: 'Non Retail Claims',
    documentSubTypeId: 3,
    documentSubTypeText: 'Damage',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 13,
    documentTypeText: 'External Damages',
    documentSubTypeId: 4,
    documentSubTypeText: 'Domestic',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 11,
    documentTypeText: 'C3',
    documentSubTypeId: 3,
    documentSubTypeText: 'Damage',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 11,
    documentTypeText: 'C3',
    documentSubTypeId: 2,
    documentSubTypeText: 'Shortage',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 13,
    documentTypeText: 'External Damages',
    documentSubTypeId: 5,
    documentSubTypeText: 'Imports',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 12,
    documentTypeText: 'Non Retail Claims',
    documentSubTypeId: 2,
    documentSubTypeText: 'Shortage',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 11,
    documentTypeText: 'C3',
    documentSubTypeId: 1,
    documentSubTypeText: 'Accidents',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Transport Claims',
    documentTypeId: 14,
    documentTypeText: 'Import Damage',
    documentSubTypeId: null,
    documentSubTypeText: null,
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      receiptDate: true,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      documentNotification: true,
      claimReceipts: true,
      containerNumber: false,
      totalCartons: false,
    },
    mandatoryFields: {
      documentTypeId: false,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      locationId: false,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      invoiceDate: true,
      shipDate: true,
      receiptDate: false,
      cartonsBilled: true,
      cartonsReceived: true,
      shortageCartons: true,
      shortageAmount: true,
      trailerNumber: true,
      trackingNumber: true,
      trailerType: true,
      claimType: true,
      itemLevelShortage: true,
      containerNumber: false,
      totalCartons: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 74,
    documentTypeText: 'IOT - Import On Time',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'IOT',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: true,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: true,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 75,
    documentTypeText: 'IFR - Import Fill Rate',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'IFR',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: true,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: true,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 76,
    documentTypeText: 'PBA - Physical Barcode Accuracy',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'PBA',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: true,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: true,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 85,
    documentTypeText: 'PCA - Physical Casepack Accuracy',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'PCA',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: true,
      departmentId: true,
      classId: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: true,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: true,
      classId: false,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 86,
    documentTypeText: 'IAD - Item Attribute Audit DC',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'IAD',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: false,
      classId: false,
      tcin: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: true,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: false,
      classId: false,
      tcin: true,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
    },
  },
  {
    caseType: 'Internal Processing',
    caseSubType: 'Import Claims',
    documentTypeId: 87,
    documentTypeText: 'IAS - Item Attribute Audit Stores',
    documentSubTypeId: null,
    documentSubTypeText: null,
    claimType: 'IAS',
    displayFields: {
      originalDocumentAmount: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: false,
      classId: false,
      tcin: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: true,
    },
    mandatoryFields: {
      documentTypeId: true,
      disputedDocumentAmount: true,
      purchaseOrderNumber: false,
      departmentId: false,
      classId: false,
      tcin: true,
      carrierPurchaseOrderNumber: false,
      reasonCode: true,
      originalDocumentAmount: true,
      cbdcDocumentDate: false,
      retailAmount: false,
      inventoryRemovalId: false,
      locationId: false,
    },
  },
]
